export const FormConstants = {
	phoneUsage: 'phoneusage',
	phone: 'phone',
	phoneUsageHome: 'home',
	phoneUsageMobile: 'mobile',
	CommunicationEmail: 'email',
	CommunicationText: 'text',
};

export const AgeConstants = {
	adult: 18,
	maxAge: 121,
};
